import { DEFAULT_INSTITUTIONS } from '@/views/LinkedData/utils/const'
import { LinkedDataConnector } from '@types'

const trimConnectorName = (name: string) => {
  return name.replaceAll(' ', '').toLowerCase()
}

export const getConnectorLogo = (connector: LinkedDataConnector) => {
  if (connector.logo) {
    return connector.logo
  }
  const source = trimConnectorName(connector.source)
  const ext = source === 'americanexpress' ? 'png' : 'svg'

  if (
    !DEFAULT_INSTITUTIONS.some(
      item =>
        item.institution_id === source ||
        trimConnectorName(item.name) === source,
    ) &&
    source !== 'carta'
  )
    return

  return `/assets/img/connectors/${source}.${ext}`
}
